import { render, staticRenderFns } from "./TagsManager.vue?vue&type=template&id=222e2078"
import script from "./TagsManager.vue?vue&type=script&lang=ts"
export * from "./TagsManager.vue?vue&type=script&lang=ts"
import style0 from "./TagsManager.vue?vue&type=style&index=0&id=222e2078&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports